module.exports = __webpack_public_path__ + "img/star-purple.9da4bb6c.svg";